import {getTwilioToken} from '@/services/twilio'

const TWILIO_TOKEN_REFRESH_INTERVAL = 30 * 60 * 1000

export function useTwilioToken() {
  return useQuery({
    queryKey: ['twilioToken'],
    queryFn: async () => getTwilioToken(),
    staleTime: TWILIO_TOKEN_REFRESH_INTERVAL,
    refetchInterval: TWILIO_TOKEN_REFRESH_INTERVAL,
    refetchOnWindowFocus: false,
    refetchOnReconnect: true,
  })
}
